import BButtonGroup from '../button/button-group'

/* istanbul ignore next */
BButtonGroup.install = function (Vue) {
  Vue.component(BButtonGroup.name, BButtonGroup)
}

export default BButtonGroup
